import Service, { inject as service } from "@ember/service"
import _ from "lodash"

export default class CardStackTemplateUpdater extends Service {
  @service("ember-store") store

  init() {
    super.init(...arguments)
    this.subscriptions = {}
  }

  subscribe(cardStackId, cardStackTemplateId) {
    this.subscriptions[cardStackId] = cardStackTemplateId
  }

  unsubscribe(cardStackId) {
    this.subscriptions = _.omit(this.subscriptions, cardStackId)
  }
}
